import { Approver } from "../../../Reusables/components/ClientApproverSetting/ClientApproverSetting.utils";

/**
  * Compares two lists of approvers and checks if they are equal.
  * Equality is determined by comparing the `FirmDetailId` of each approver after sorting.
  *
  * @param a - The first list of approvers.
  * @param b - The second list of approvers.
  * @returns `true` if both lists contain the same approvers in any order, otherwise `false`.
  */
export const areApproversEqual = (a: Approver[], b: Approver[]): boolean => {
  const activeA = a.filter((approver) => approver.Active === "Y");
  const activeB = b.filter((approver) => approver.Active === "Y");

  if (activeA.length !== activeB.length) return false;

  const sortByOrder = (list: Approver[]) =>
    [...list].sort((x, y) => (x.ApproverOrder ?? 0) - (y.ApproverOrder ?? 0));

  const sortedA = sortByOrder(activeA);
  const sortedB = sortByOrder(activeB);

  return sortedA.every(
    (item, index) =>
      item.FirmDetailId === sortedB[index].FirmDetailId &&
      item.Active === sortedB[index].Active &&
      item.ApproverOrder === sortedB[index].ApproverOrder
  );
};